import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { ActionButton, Backdrop } from '../../components/Themed.js';
import { print } from '../../data/app/AppActions.js';
import './Confirmation.css';
import ConfirmationTick from './ConfirmationTick.js';
import { t } from '../../locales';

class Confirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: null,
    };
  }

  componentDidMount() {
    const timer = setTimeout(() => this.props.history.push('/'), 30000);
    this.props.print(this.props.serviceNumber, this.props.printerMac);
    this.setState({ timer });
  }

  componentWillUnmount() {
    clearTimeout(this.state.timer);
  }

  render() {
    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="confirmation-title">
              <ConfirmationTick /> {t('confirmation.class_check_in_confirmed')}
            </div>
            <div className="content">
              <div
                style={{height: '200px'}}
              />
              <Link to="/">
                <ActionButton>{t('confirmation.button_done')}</ActionButton>
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    serviceProviderTerm: state.app.serviceProviderTerm,
    serviceNumbersEnabled:
      state.app.businessInfo.company.service_numbers_enabled,
    serviceNumber: state.classes.classSessionEnrollment
      ? state.classes.classSessionEnrollment.id
      : '---',
    printerMac: state.app.printerMac,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { print }
  )(Confirmation)
);
